/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Cancel_TitleInputs */

const en_settings_billing_cancel_title = /** @type {(inputs: Settings_Billing_Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel subscription`)
};

const zh_settings_billing_cancel_title = /** @type {(inputs: Settings_Billing_Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消订阅`)
};

/**
* | output |
* | --- |
* | "Cancel subscription" |
*
* @param {Settings_Billing_Cancel_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_cancel_title = /** @type {((inputs?: Settings_Billing_Cancel_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Cancel_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_cancel_title(inputs)
	return zh_settings_billing_cancel_title(inputs)
});
export { settings_billing_cancel_title as "settings.billing.cancel_title" }